module.exports = __webpack_public_path__ + "static/media/brego3595.684e2bd8.jpg";